import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import type { FullAuditEntry, PaginatedResponse } from '@/lib/types'

interface AuditParams {
  page?: number
  per_page?: number
  admin_user?: string
  action?: string
  target_type?: string
  from?: string
  to?: string
}

const AUDIT_KEY = ['audit'] as const

export function useAuditLog(
  params?: AuditParams,
): ReturnType<typeof useQuery<PaginatedResponse<FullAuditEntry>>> {
  return useQuery({
    queryKey: [...AUDIT_KEY, params],
    queryFn: () =>
      apiClient.get<PaginatedResponse<FullAuditEntry>>(
        endpoints.audit.list({
          page: params?.page,
          per_page: params?.per_page,
          admin_user: params?.admin_user,
          action: params?.action,
          target_type: params?.target_type,
          from: params?.from,
          to: params?.to,
        }),
      ),
  })
}
